'use client';
import { shouldUseYotpoReviews } from '@/utils/helpers';
import { loadYotpoScript } from '@/utils/loadYotpoScript';
import { useEffect, useState } from 'react';
import { useNavigationEvent } from './useNavigationEvent';

export const useYotpoScript = () => {
  const [scriptFetched, setScriptFetched] = useState(false);

  useEffect(() => {
    if (!shouldUseYotpoReviews()) return;

    /*
      In React strict mode, components re-render twice to check for
      unhandled side effects. This causes a race condition where the
      Yotpo script updates the DOM but then the re-render blows away
      the Yotpo changes. So while not a problem in production, in
      development mode we need to delay the script fetching so the DOM
      settles first.
    */
    if (process.env.NODE_ENV === 'development') {
      if (!scriptFetched) {
        const rerenderWaitTime = 1000;
        setTimeout(loadYotpoScript, rerenderWaitTime);

        setScriptFetched(true);
      }
    } else {
      loadYotpoScript();
    }
  }, [scriptFetched]);

  useNavigationEvent(() => {
    if (!shouldUseYotpoReviews()) return;
    if (
      typeof window !== undefined &&
      window.yotpo &&
      window.yotpo.refreshWidgets
    ) {
      window.yotpo.refreshWidgets();
    }
  });
};
